/* eslint-disable @nx/enforce-module-boundaries */
import { Heading, Stack, Box, Text, HStack } from '@mybridge/ui';
import { isMobile, isTablet } from 'react-device-detect';
import { MyDiskMenu } from 'v4/components/disk/my-disk/main-menu';
import { useDisclosure } from '@mybridge/ui';
import { MyBridgeCircleIcon } from '@mybridge/icons';
import Link from 'next/link';
import { Input, InputGroup, InputLeftElement } from '@mybridge/ui/input';
import { SearchIcon } from '@mybridge/icons/Search';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export const MyDiskLeftPanel = ({ ...props }) => {
  const sideDrawerDisc = useDisclosure();
  const { t } = useTranslator();
  return (
    <>
      <Stack
        {...props}
        p={['', 4]}
        pt={[0, 4]}
        // w="20%"
        backgroundColor="white"
        minW="200px"
        overflowY="auto"
        css={{
          /* Customize the scrollbar */
          '&::-webkit-scrollbar': {
            width: '0px',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
            borderRadius: '4px',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: '#f1f1f1',
            borderRadius: '4px',
          },
        }}
      >
        {!isMobile && (
          <Heading
            fontSize="16px"
            fontWeight="400"
            color="brandPrimary.500"
            pt="10%"
          >
            {t('navigation.myDisk') || "myDisk"}
          </Heading>
        )}
        <MyDiskMenu />
      </Stack>
    </>
  );
};
